const config = {
    duration: 2000,
    reset: false,
  };
  
  export default config;
  